<template>
  <div class="aha-select-wrp">
    <select
      :disabled="disabled"
      :required="required"
      :value="value"
      @change="$emit('change', $event.target.value)"
      class="aha-select"
    >
      <slot />
    </select>
    <aha-icon
      class="absolute pointer-events-none right-2"
      name="arrow"
      height="14"
      width="14"
      viewBox="0 0 24 24"
    />
  </div>
</template>

<script>
import AhaIcon from '../Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
      type: [String, Number],
    },
    required: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-select-wrp {
    @apply relative flex flex-row items-center;
}

.aha-select {
  @apply appearance-none overflow-ellipsis;
  @apply pl-2 pr-6 py-2 text-sm rounded w-full border border-secondary-20;
  @apply focus:bg-primary-20 focus:border-primary-90 focus:outline-none;
  @apply placeholder-base-70;
}

.aha-select:disabled {
  @apply cursor-not-allowed bg-base-30;
}

.aha-select:hover:not(:disabled) {
  @apply bg-primary-20 border-primary-90;
}

</style>
